// const app = {
export default {
    namespaced: true,
    state: {
        mainDomain: 'www.iclass30.com',
        aliyunPath: 'https://fs.iclass30.com',
        defalutImgPath: 'https://fs.iclass30.com/aliba/resources/default/upload/default.png',
        domain: process.env.VUE_APP_DOMAIN,
        is_collapse: false, // 折叠状态
        leftMenuShowState: true,// 左边菜单是否显示
        size: 10, // 分页每页个数
        runtimeEnvir: 'web',// 运行时环境 默认是web  当为screen 时 隐藏左边菜单和顶部
        logoPathPre: 'https://fs.iclass30.com/aliba/console/logo/',
        appType: -1, // 应用类型 -1默认1综评
    },
    mutations: {
        SET_COLLAPSE_STATUS(state, data) {
            state.is_collapse = data;
        },
        SET_RUNTIMEENVIR(state, data) {
            state.runtimeEnvir = data;
        },
        SET_LEFT_MENU_SHOW_STATE(state, data) {
            state.leftMenuShowState = data;
        },
        SET_APP_TYPE(state, data) {
            state.appType = data;
        },
    },
    actions: {
        // 设置折叠状态
        setCollapseStatus({commit}, data) {
            commit('SET_COLLAPSE_STATUS', data);
        },
    }
};
// export default app;